<template>
	<div id="footer">
		<div class="footer-content">
			<div class="content-left">
				<h3>关于</h3>
				<p>
					<!-- &nbsp;&nbsp;&nbsp;&nbsp; -->
					斗牛财经隶属于北京中方信富投资管理咨询有限公司，是一款面向个人投资者的垂直型股票交流互动社区，以强化的中方信富投研团队为后盾，视频教学和文字直播相结合，分析师和投资者实现零距离沟通，受到广大投资者的高度认可，为股民提供专业的、贴心的、具有高质量的参考价值的服务是斗牛财经贯彻的核心理念
				</p>
			</div>
			<div class="content-right">
				<div class="right-img">
					<img src="../../assets/img/index/wx_official.png" alt="">
					<p>关注公众号</p>
				</div>
				<div class="right-img">
					<img src="../../assets/img/footer/AndroidDownload.png" alt="">
					<p>Android下载</p>
				</div>
				<div class="right-img">
					<img src="../../assets/img/footer/iOSDownload.png" alt="">
					<p>IOS下载</p>
				</div>
			</div>
			
		</div>
		<div class="footer-bottom">
			<div class="bottom-content">
				<p>
					
					<span>北京中方信富投资管理咨询有限公司</span>
					&nbsp;&nbsp;&nbsp;
					<span>版权所有&nbsp;www.douniu8.com</span>
					&nbsp;&nbsp;&nbsp;
					<span>客服热线：400-8888115</span>
					&nbsp;&nbsp;&nbsp;
					<span>客服邮箱：callcenter@zfxf.com</span>
				</p>
				<p>
					<span>京公网安备 11010502036470号</span>
					&nbsp;&nbsp;&nbsp;
					<span>经营许可证编号：京B2-20190657</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'v-footer',
	}
</script>

<style scoped>
	#footer{
		background-color: #606060 ;
		margin: 0 auto;
		min-width: 1314px;
	}
	
	.footer-content{
		width: 1250px;
		margin: 0 auto;
		color: #e7e7e7;
		display: flex;
	}
	.footer-content .content-left{
		text-align: left;
		width: 60%;
		margin-top: 5%;
	}
	.footer-content .content-left p{
		font-size: 1.125rem;
	}
	
	.footer-content .content-right{
		width: 50%;
		
		margin-top: 8%;
		text-align: center;
	}
	
	.footer-content .content-right .right-img{
		display: inline-block;
		margin: 0 1.25rem;
	}
	
	
	.footer-bottom{
		color: #969696;
		margin-top: 62px;
	}
	
	.footer-bottom .bottom-content{
		border-top: 2px solid #565656;
		margin: 0 auto;
		width: 70%;
	}

	.bottom-content p{
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue